<!--
 * @Author: r_yanxu r_yanxu@ctx.com.sg
 * @LastEditors: weijinpeng
 * @Date: 2024-03-05 14:27:19
 * @Description: 
-->
<template>
  <div :id="id" class="page10Echart"></div>
</template>

<script>
import { reactive, toRefs, onBeforeMount, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router';
import * as echarts from 'echarts';
import { usePdftStore } from '@/store/pdf'
export default {
  name: 'echarts',
  props: {
    id: {
      type: String,
      default: () => null
    },
    center: {
      type: Array,
      default: () => ['35%', '35%']
    },
    data:{
      type: Array,
      default: () => []
    },
  },
  setup(props) {
    const data = reactive({
      id: props.id,
      center: props.center,
      data:props.data
    })
    //引入数据管理库
    const PdftStore = usePdftStore()

    const chartOption = (data) => {
      const myChart = echarts.init(document.getElementById(data.id))
      myChart.setOption({
        color: [
          '#D7E1F2',
          '#013C89',
        ],
        title: {
          show: false
        },
        legend: {
          show: false,
        },
        tooltip: {
          show: false,
        },

        series: [
          {
            name: 'Access From',
            type: 'pie',
            radius: '65%',
            center: data.center,
            data: data.data,
            labelLine: {
              show: false
            },
            label: {
              show: false,
              position: 'center',
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }, true)
    }

    onBeforeMount(() => { })
    onMounted(() => {
      chartOption(data)
    })
    return {
      PdftStore,
      ...toRefs(data),
    }
  },
}

</script>
<style scoped lang='less'>
.page10Echart {
  width: 100%;
  height: 100%;
}
</style>